<template>
  <div>
    <v-row>
      <v-col md="9" cols="8" :class="from === 'contact-person' ? 'py-0' : ''">
        <slot name="buttonsColumn"></slot>
      </v-col>
      <v-col
        md="3"
        cols="4"
        v-if="showButton"
        :class="from === 'contact-person' ? 'py-0' : ''"
        class="text-right"
      >
        <v-btn x-small text :title="'Previous'" class="pointer" @click="prev()">
          <v-icon
            color="grey"
            small
            v-text="$getIcon('mdiArrowLeftBold')"
          ></v-icon>
        </v-btn>
        <v-btn x-small text :title="'Next'" class="pointer" @click="next()">
          <v-icon
            small
            color="grey"
            v-text="$getIcon('mdiArrowRightBold')"
          ></v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <div ref="carousel">
      <slot name="carousel"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import Siema from "siema";

export default {
  props: {
    options: {
      type: Object,
      default() {
        return {
          perPage: {
            0: 2,
            800: 10,
            1240: 10
          }
        };
      }
    },
    from: {
      type: String,
      default: ""
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    playDuration: {
      type: Number,
      default: 6000
    },
    current: {
      type: Number,
      default: 0
    },
    ready: {
      type: Boolean,
      default: true
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      playing: this.autoPlay,
      time: this.playDuration
    };
  },
  mounted() {
    if (this.ready) this.init();
  },
  beforeDestroy() {
    if (this.playing) clearInterval(this.$options.play_timer);
    this.destroy();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        if (this.options === undefined) this.options = {};
        this.options.selector = this.$refs.carousel;
        this.options.onInit = () => {
          this.$emit("init");
        };
        this.options.onChange = () => {
          this.$emit("update:current", this.siema.currentSlide);
          if (this.playing) {
            clearTimeout(this.$options.play_timer);
            this.$options.play_timer = setTimeout(() => {
              this.siema.next();
            }, this.time);
          }
          this.$emit("change");
        };
        if (this.playing) this.play(this.time);
        this.siema = new Siema(this.options);
      });
    },
    // Basic wrap...
    prev(slide, callback) {
      this.siema.prev(slide, callback);
    },
    next(slide, callback) {
      this.siema.next(slide, callback);
    },
    goTo(index, callback) {
      this.siema.goTo(index, callback);
    },
    remove(index, callback) {
      this.siema.remove(index, callback);
    },
    insert(item, index, callback) {
      this.siema.insert(item, index, callback);
    },
    prepend(item, callback) {
      this.siema.prepend(item, callback);
    },
    append(item, callback) {
      this.siema.append(item, callback);
    },
    destroy(restoreMarkup = false, callback) {
      this.siema.destroy(restoreMarkup, callback);
    },
    play(time = 6000) {
      this.time = time;
      this.playing = true;
      this.$options.play_timer = setTimeout(() => {
        this.siema.next();
      }, time);
      this.$emit("update:playing", true);
    },
    stop() {
      this.playing = false;
      clearTimeout(this.$options.play_timer);
      this.$emit("update:playing", false);
    }
  }
};
</script>
